// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/pace/pace-theme-corner-indicator.min.css
// module id = 1595
// module chunks = 81